import { Link } from "react-router-dom";
import { PageHeader } from "../../components/admin/PageHeader";
import { ProfileListPanel, PROFILE_COLUMNS } from "../../components/admin/ProfileListPanel";
import { BULK } from "../../components/admin/bulkActions";

const TYPE_COL = {
  key: "type", label: "Type",
  render: (r) => (
    <span data-testid={`approval-type-${r.id}`} className={`rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase ${r.has_pending_edit ? "bg-[#F5E6BA] text-[#7A0016]" : "bg-emerald-50 text-emerald-800"}`}>
      {r.has_pending_edit ? "Edited" : "New"}
    </span>
  ),
};

export default function ProfileApproval() {
  return (
    <div data-testid="profile-approval-page">
      <PageHeader eyebrow="Queue" title="Profile Approval" />
      <p className="-mt-3 mb-5 text-sm text-[#8C6A6C]">New and client-edited profiles waiting for review. Open a profile to see exactly what changed.</p>
      <ProfileListPanel
        base={{ status: "pending" }}
        hideStatus
        columns={[TYPE_COL, ...PROFILE_COLUMNS.filter((c) => c.key !== "status")]}
        bulkActions={[BULK.approve, BULK.reject, BULK.hold]}
        rowActions={(r) => <Link to={`/admin/profiles/${r.id}`} data-testid={`review-${r.id}`} className="text-xs font-semibold text-[#C59B27] hover:text-[#7A0016]">Review</Link>}
        exportName="pending-profiles"
        exportTitle="Real Match Matrimony - Pending Approvals"
      />
    </div>
  );
}
